import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { motion } from 'framer-motion';

function LogoutButton() {
  const { logout } = useAuth0();

  return (
    <motion.button 
      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
      className="w-full text-left text-sm text-red-600 font-medium hover:text-red-700 transition-colors flex items-center"
      whileHover={{ x: 2 }}
      whileTap={{ scale: 0.98 }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      Log Out
    </motion.button>
  );
}

export default LogoutButton; 